<template>
	<div id="voucher_word"  class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">	
			<el-form label-width="90px" inline label-position="left" style='text-align: right;'>
				<el-form-item>
					<el-button size="small" class='minButton' @click="editorMethods">添加</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 公共table 样式 -->
		<div class="table-item-public">
			<public-table :table='tableData' @onHandleoperate="handleOperation">
				<template slot-scope="props" slot="standard">
					<span v-text='props.scope.row.standard?"是":"否"'></span>
				</template>
			</public-table>
		</div>
	
		
		<!-- 添加公式弹出层 -->
		<el-dialog :title="dialog.text" :visible.sync="dialog.modal" width="420px" :close-on-click-modal="false" class='default-dialog'> 
			<div class="form-item-public">
				<el-form  label-width="60px" ref="modalData" :model="modalData" :rules="dialogRules">
					<el-form-item prop="code" label="币别:" >
						<el-input v-model="modalData.code" size="mini" placeholder="示例：USD"></el-input>
					</el-form-item>
					<el-form-item prop="name" label="名称:" >
						<el-input v-model="modalData.name" size="mini" placeholder="示例：美元"></el-input>
					</el-form-item>
					<el-form-item prop="exchangerate" label="汇率:" >
						<el-input v-model="modalData.exchangerate" size="mini" placeholder="示例：6.80000"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="dialog.modal = false">取消</el-button>
				<el-button size="small" class='minButton' @click="addCurreCode">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		return {
			title:'这个是主页',
			dialog:{
				modal:false,
				text:''
			},
			modalData:{
				code:'',
				name:'',
				exchangerate:'',
				id: ''
			},
			dialogRules:{
				code:[{
					 required: true,validator: this.isCode,trigger: 'blur'
				}],
				name:[{
					required: true, message: '货币名称不能为空！' , trigger: 'blur'
				}],
				exchangerate:[{
					required: true, validator: this.isexChangerate , trigger: 'blur'
				}]
			},
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: true,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [
					{
						label: '编码',
						value: 'code',
						show: 'normal'
					},
					{
						label: '名称',
						value: 'name',
						show: 'normal'
					},
					{
						label: '汇率',
						value: 'exchangerate',
						show: 'normal'
					},
					{
						label: '是否本位币',
						value: 'standard',
						show: 'template'
					},
				],
				operation: {
					label: '操作',
					value: 'operation',
					data: [
					{
						label:"编辑",
						value:'editBtn'
					},{
						label:"删除",
						value:'delete'
					}]
				},
				data: [],
				page: {
					pageNo: 1,
					pageSize: 10,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			}
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			//快速访问
			this.$http.post('/foreignCurrency/findAll',{

			}).then(res=>{
				if(res.data.code=='1') {
					this.tableData.data = res.data.data;

				}
			});
		},
		//币别验证
		isCode(rule,value,callback){
			if(!value){
				return callback( new Error('币别不能为空！') )
			}
			setTimeout(()=>{
				let reg = /^[A-Z]{3}$/;
				if(!reg.test(value)){
					return callback( new Error('请输入三位英文大写字母！') )
				}else{
					return callback();
				}
			})		},
		//汇率验证
		isexChangerate(rule,value,callback){
			if(!value){
				return callback( new Error('汇率不能为空！') )
			}
			setTimeout(()=>{
				if(!Number(value)){
					return callback( new Error('汇率只能是数字！') )
				}else{
					return callback();
				}
			})
		},
		// 确认添加/修改
		addCurreCode(){
			const _=this;
			_.$refs.modalData.validate((valid)=>{
				if(valid){
					_.dialog.modal = false;
					_.tableData.loading = true;
					try {
						_.$http.post('/foreignCurrency/save', _.modalData).then(res=>{
							_.tableData.loading = false;
							if(res.data.code=='1') {
								_.$message({
									type: 'success',
									message: '操作成功！',
									showClose: true
								})
								_.init();
							}else {
								
							}
						});				
					}catch(e) {

					}
				}
			})
		},//表格操作按钮
		handleOperation(data){
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			const {methods,row} = data;
			switch (methods) {
				case 'editBtn':
					this.editorMethods(row);
					break;
				case 'delete':
					this.deleteMethods(row);
					break;
			}
		},//修改/增加列表数据方法
		editorMethods(row){
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.dialog.modal = true;
			this.$nextTick(()=>{
				if(row.id){
					this.dialog.text = '修改币别';
					this.modalData = Object.assign({}, this.modalData, {
						code:row.code,
						name:row.name,
						exchangerate:row.exchangerate,
						id:row.id,
					});

					this.$refs.modalData.resetFields()
				}else{
					this.dialog.text = '添加币别';
					this.modalData = Object.assign({}, this.modalData, {
						code:null,
						name:null,
						exchangerate:null,
						id:null,
					});
					this.$refs.modalData.resetFields()
				}
			})
			
		},//删除列表数据方法
		deleteMethods(row){
			const _=this;
			if(!row.id) {
				return _.$message({
							type: 'error',
							message: '异常操作！',
							showClose: true
						})
			}
			let param = {id: row.id};
			this.$confirm('此操作将永久删除该币别, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
					_.$http.post('/foreignCurrency/delete',param).then(res=>{
						if(res.data.code=='1') {
							 _.$message({
								type: 'success',
								message: '删除成功！',
								showClose: true
							})
							_.init();
						}else {
							 _.$message({
								type: 'error',
								message: '删除失败！',
								showClose: true
							})
						}
					})
				}).catch(e=>{

				})
		},

	},
	mounted() {
		
	},
}
</script>

<style lang="less">
	#voucher_word{
		.el-dialog__title {
			font-size: 16px;
			font-weight: 700;
			color: #269D7B;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/currencyCode.vue